import BaseComponentController from '.././base-component.controller';

class RadioInputController extends BaseComponentController {
    constructor(_, componentRegistryService,$q) {
        super(_, componentRegistryService,$q);
        this.vm = {
            errors:[]
        };
    }

    init() {
        this.vm = {
            errors:[]
        };
        if (this.checked !== null) {
            if (this.checked) {
                this.model = true;
            }
        }
    }

    validState() {
        return this.model !== null;
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this.model === null) {
            this.vm.errors = [`"${this.fieldName}" is a required field`];
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }
}

RadioInputController.$inject = ['_', 'componentRegistryService', '$q'];

let radioInputComponent = {
    controller: RadioInputController,
    bindings: {
        modelName:'@',
        fieldName:'@',
        readonly:'<',
        checked:'<'
    },
    templateUrl:`app/components/radio-input/radio-input.html`
};

export default radioInputComponent;


// WEBPACK FOOTER //
// ./app/components/radio-input/radio-input.component.js